import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { useSearchFilters } from '../../searchFilters.context';
import { filterStrategyAssets } from '../../utils/definitions';
/** Represents a dropdown component that is used to select a filtering strategy */
export const FilterStrategy = () => {
    const { strategy, updateStrategy } = useSearchFilters();
    const strategies = ['all', 'any'];
    return (_jsx(DropdownButton, Object.assign({ buttonProps: { variant: 'tertiary' }, fixed: true, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsx(ButtonList, { children: strategies.map((item) => (_jsx(ButtonList.Item, Object.assign({ isSelected: item === strategy, onClick: () => {
                        updateStrategy(item);
                        toggleDropdown();
                    } }, { children: filterStrategyAssets[item].description }), item))) })) }) }, { children: filterStrategyAssets[strategy].label })));
};
